export interface Spacing {
  xxxs: '8px';
  xxs: '16px';
  xs: '24px';
  s: '32px';
  m: '48px';
  l: '80px';
  xl: '120px';
  xxl: '160px';
  xxxl: '240px';
}

export const spacing: Spacing = {
  xxxs: '8px',
  xxs: '16px',
  xs: '24px',
  s: '32px',
  m: '48px',
  l: '80px',
  xl: '120px',
  xxl: '160px',
  xxxl: '240px',
};
